<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Transferir Participante' | translate}}</ion-title>
  </ion-buttons>
</ion-header>


<ion-content class="schedule-content">
  <div class="gradient-extendido"></div>

  <div *ngIf="!grupoL">
    <sem-registro>
    </sem-registro>
  </div>

  <div *ngIf="grupoL">
    <ion-card-content class="remove-card">
      <div>
        <ion-searchbar show-cancel-button="never" (ionCancel)="onCancel()" placeholder="{{'Buscar' | translate}}"
          [(ngModel)]="filtroGrupo" (ionInput)="onInputGrupo()" class="custom">
        </ion-searchbar>

        <ion-list class="pointer" *ngFor="let grupo of grupoList" (click)="openPage(grupo.id);">
          <ion-item>
            <ion-note slot="start">
              <i class="fas fa-users icon-list"></i>
            </ion-note>

            <ion-label>
              <h3>{{grupo.nome}}</h3>
            </ion-label>

            <i class="fa-regular fa-chevron-right icon-list"></i>
          </ion-item>
        </ion-list>

        <ion-infinite-scroll *ngIf="paginationGrupo.currentPage*1 < paginationGrupo.pageCount*1"
          (ionInfinite)="loadGrupo($event)">
          <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </ion-card-content>
  </div>
</ion-content>